import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

// SUPER_ADMIN peer-workspace navigation. Extracted verbatim from the dashboard so the same row
// persists across Admin pages. Internally role-gated: renders nothing for non-SUPER_ADMIN (so an
// ACCOUNTS user on /concierge sees no Admin nav). Active destination uses the existing
// btn-primary/btn-ghost convention.
const DESTINATIONS = [
  { to: "/app", label: "Shipments", testid: "shipments-link" },
  { to: "/admin/airports-routes", label: "Airports & Routes", testid: "airports-routes-link" },
  { to: "/accounts/concierge", label: "Concierge", testid: "concierge-link" },
  { to: "/admin/pricing-settings", label: "Pricing", testid: "pricing-settings-link" },
  { to: "/admin/promo-codes", label: "Promo Codes", testid: "promo-codes-link" },
  { to: "/admin/cargo-acceptance", label: "Cargo Acceptance", testid: "cargo-acceptance-link" },
  { to: "/admin/clients", label: "Clients", testid: "clients-link" },
  { to: "/admin/leads", label: "Leads", testid: "leads-link" },
  { to: "/admin/review-requests", label: "Review Requests", testid: "review-requests-link" },
  { to: "/admin/legal", label: "Legal", testid: "legal-admin-link" },
  { to: "/admin/users", label: "Manage users", testid: "manage-users-link" },
];

export default function AdminNav({ className = "" }) {
  const { profile } = useAuth();
  const { pathname } = useLocation();
  if (!profile || profile.role !== "SUPER_ADMIN") return null;
  return (
    <div
      className={`flex items-center gap-3 min-w-0 overflow-x-auto whitespace-nowrap [&>*]:shrink-0 lg:overflow-visible lg:whitespace-normal ${className}`}
      data-testid="admin-nav"
    >
      {DESTINATIONS.map((d) => {
        const active = pathname === d.to || pathname.startsWith(d.to + "/");
        return (
          <Link key={d.to} to={d.to} className={active ? "btn-primary" : "btn-ghost"}
                data-testid={d.testid} aria-current={active ? "page" : undefined}>
            {d.label}
          </Link>
        );
      })}
    </div>
  );
}
